<script setup lang="ts">
import { ref, reactive } from 'vue';
import BaseForm from '@/shared/components/BaseForm.vue';
import type { CTSpec } from '../models/SolshareSystemSpec';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import BaseRadio from '@/shared/components/BaseRadio.vue';
import { useDeviceSpecificationStore } from '../stores/deviceSpecificationStore';
import { onMounted } from 'vue';
import { isEmptyObject } from '@/utils/object';
import {
  CT_RATING_OPTIONS,
  findDefaultCTRating,
} from '../constants/config-constants';
import ChevronRightSVG from '@shared/assets/icon/chevron-right.svg';

const props = defineProps<{
  serialNumber: string;
}>();
const store = useDeviceSpecificationStore();
const emit = defineEmits(['next']);
const formRef = ref();
const formData = reactive<CTSpec>({
  rating: findDefaultCTRating(),
});

onMounted(() => {
  const spec = store.solshareSystemSpec;
  if (spec && !isEmptyObject(spec)) {
    const storeRating = spec.ctSpec?.rating;
    formData.rating = storeRating ? storeRating : findDefaultCTRating();
  }
});

const handleSubmit = async () => {
  try {
    await formRef.value?.validate();
    await store.setCommissionConfig(props.serialNumber, formData);
    emit('next', formData);
  } catch (error) {
    console.error('Validation failed:', error);
  }
};
</script>

<template>
  <div class="container">
    <BaseForm
      ref="formRef"
      :model="formData"
      @finish="handleSubmit"
      id="ct-form"
    >
      <a-form-item name="rating">
        <BaseRadio
          v-model="formData.rating"
          :options="CT_RATING_OPTIONS"
          data-tn="ct-rating-input"
        />
      </a-form-item>
    </BaseForm>
    <div class="action-container">
      <ButtonPrimary
        html-type="submit"
        form="ct-form"
        class="submit-button"
        block
        data-tn="ct-submit"
      >
        Next
        <template #iconRight>
          <ChevronRightSVG class="chevron-right-icon" />
        </template>
      </ButtonPrimary>
    </div>
  </div>
</template>

<style lang="less" scoped>
.container {
  width: 100%;
}

.action-container {
  width: 100%;
  margin-top: @margin-top-end-of-page-section;
}
</style>
